import backendRequestUtil from 'utils/backendRequest.util';

export default class TestContactsService {

  static async getTestContacts() {
    const {success, body, error} = await backendRequestUtil.get('/api/testContacts');
    return success ? {success, payload: body.testContacts} : {success, error};
  }

  static async sendCampaignTest(lineId, toTestContacts, flow, map, options = {}) {
    const bodyRequest = {from: lineId, toTestContacts, flow, map, ...options};
    const {success, error} = await backendRequestUtil.post('/api/testCampaign', bodyRequest);
    return success ? {success} : {success, error};
  }

  static async registerTestContact(phone, name) {
    const bodyRequest = {phone, name};
    const {success, body, error} = await backendRequestUtil.post('/api/testContact', bodyRequest);
    if(!success && !error.internal) {
      if(/^número de teléfono inválido$/i.test(error.message)) {
        error.code = 'INVALID_PHONE_NUMBER';
      }
      if(/^el número de teléfono ya se encuentra asociado a un contacto$/i.test(error.message)) {
        error.code = 'ALREADY_EXIST';
      }
    }
    return success ? {success, payload: body} : {success, error};
  }

}